import type { ListingDescriptionValues } from "@slfinrtl/ui-bff-routes"
import type { LocalizedTextAreaFieldProps } from "src/components/form/localizedTextAreaField/LocalizedTextAreaField"

export interface ListingDescriptionFields {
	listingDescription: LocalizedTextAreaFieldProps
}

type FieldName = keyof ListingDescriptionValues

const listingDescriptionName: FieldName = "listingDescription"

export const listingDescriptionFieldNames = {
	listingDescriptionName,
}
